import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useDownloadAlloyDocumentMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		async ({ id, token }: { id: string; token: string }) => {
			if (!token) return Promise.reject("Token is missing");
			return autoChecklistService.downloadAlloyDocument(id, token);
		},
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Alloy Result has been downloaded successfully",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useDownloadAlloyDocumentMutation;
